/* Portal-mode helpers.
 *
 * The USKE Procurement Portal can be served two ways:
 *   1. Path-based (default): as a sub-tree of the main USKE retail site at `/portal/*`
 *   2. Standalone: at a dedicated hostname (e.g. `portal.uskesupplyllc.com`)
 *      with no path prefix.
 *
 * Set REACT_APP_PORTAL_HOSTNAME in the frontend `.env` to the dedicated
 * hostname when running a portal-only deployment — everything below picks it
 * up automatically:
 *   - `PORTAL_BASE` becomes ''  (so internal links become `/dashboard` instead of `/portal/dashboard`)
 *   - `App.js` registers the portal routes at the root path
 *
 * If the env var is empty (default), the portal lives at `/portal/*` on the
 * main retail domain.
 */
export const PORTAL_HOSTNAME = (process.env.REACT_APP_PORTAL_HOSTNAME || '').trim().toLowerCase();

export const isPortalSubdomain = () => {
  if (!PORTAL_HOSTNAME) return false;
  if (typeof window === 'undefined') return false;
  return window.location.hostname.toLowerCase() === PORTAL_HOSTNAME;
};

/** Empty string when the portal is served standalone (so links become "/dashboard").
 *  "/portal" otherwise (so links become "/portal/dashboard"). */
export const PORTAL_BASE = isPortalSubdomain() ? '' : '/portal';

/** Prefix any in-portal path. `portalPath('/dashboard')` → '/dashboard' OR '/portal/dashboard'. */
export const portalPath = (p) => {
  if (!p) return PORTAL_BASE || '/';
  if (p.startsWith('/')) return `${PORTAL_BASE}${p}`;
  return `${PORTAL_BASE}/${p}`;
};
